package com.veldekar.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A

@Composable
fun InvertibleImage(src: String, link: String, altText: String = "", width: Int? = null, height: Int? = null) {
    val isDark = ColorMode.current.isDark
    val baseModifier = if (isDark) {
        Modifier.styleModifier {
            property("filter", "invert(1) hue-rotate(180deg)")
        }
    } else {
        Modifier
    }

    val modifier = baseModifier.then(
        if (width == null || height == null) {
            Modifier
        } else {
            Modifier.width(width.px).height(height.px).styleModifier {
                property("aspect-ratio", "$width / $height")
                property("height", "auto")
            }
        }
    )

    if (link.isNotEmpty() && link != src) {
        A(href = link) {
            LazyImg(
                src = src,
                alt = altText,
                width = width,
                height = height,
                modifier = modifier
            )
        }
    } else {
        LazyImg(
            src = src,
            alt = altText,
            width = width,
            height = height,
            modifier = modifier
        )
    }
}
